/**
 * 接口数据加密白名单配置
 * @description 配置不需要加密的接口路径列表
 */

/**
 * 接口加密白名单
 * @type {Array<string>}
 * @description 白名单中的接口路径将进行数据加密
 * 支持完整路径匹配和正则表达式匹配
 */
export const ENCRYPT_WHITELIST = [
  // 示例：完整路径匹配
  '/stat/mark',
  '/resource/train/account/login',
  // 示例：使用正则表达式匹配
  // /^\/stat\//,  // 匹配所有 /stat/ 开头的接口
]

/**
 * 检查接口是否需要加密
 * @param {string} url - 接口路径
 * @returns {boolean} 如果接口在白名单中返回 true（需要加密），否则返回 false（不需要加密）
 */
export function shouldEncrypt(url) {
  if (!url || !Array.isArray(ENCRYPT_WHITELIST) || ENCRYPT_WHITELIST.length === 0) {
    return false // 默认不需要加密
  }

  return ENCRYPT_WHITELIST.some(pattern => {
    if (typeof pattern === 'string') {
      // 字符串匹配：完全匹配或路径包含
      return url === pattern || url.includes(pattern)
    } else if (pattern instanceof RegExp) {
      // 正则表达式匹配
      return pattern.test(url)
    }
    return false
  })
}

